export enum ContactViewRouteEnum {
  CONTACT_LIST = 'kontaktliste',
  PHONE_LIST = 'telefonliste',
  PHOTO_LIST = 'fotoliste',
  CHECKBOX_LIST = 'afkrydsningsliste',
  BIRTHDAY_LIST = 'fodselsdagsliste',
}
